import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import LINK from 'constants/link.const';
import { withTranslation } from 'providers/GILT.provider';
import { fromPropsToQueryString } from 'utils/converters/props/path.util';
import navFor from 'utils/links/navFor.util';

import PopupModalContainer from 'common/PopupModal';
import HeaderContainer from 'onboarding/common/Header';
import OnboardingFooter from 'onboarding/common/OnboardingFooter';
import { addService, clearServicesState, editService, getServiceTemplates } from 'onboarding/services/actions';
import { AddService } from 'onboarding/services/AddService';

const determineDescription = ({ category, categoryName, services, t }) => {
  if (services && services.length > 0) {
    return t('register.addServiceWrap.description1', { categoryName });
  }

  if (category) {
    return t('register.addServiceWrap.description2', { categoryName });
  }

  return t('register.addServiceWrap.description3');
};

class AddServiceWrap extends React.Component {
  constructor(props) {
    super(props);

    let isNewService = true;
    const isFirstPriceChange = true;
    const isFirstDurationChange = true;
    const isFirstProcessingChange = true;
    // let serviceNamed = false;
    let selectedCategory = props.categories[0];
    let isFooterButtonActive = false;
    let isNameSelected = false;
    if (props.location && props.location.state && props.location.state.category) {
      selectedCategory = props.location.state.category;
    }
    let categoryId = -1;
    if (selectedCategory && selectedCategory.id) {
      categoryId = selectedCategory.id;
    }
    let service = {
      name: '',
      category: categoryId,
      duration: moment('00:45:00', 'HH:mm:ss').format('HH:mm:ss'),
      processing: moment('00:00:00', 'HH:mm:ss').format('HH:mm:ss'),
      variable_pricing: false,
      price: '',
      role_executions: [],
    };
    if (props.currentSalon && props.currentSalon.pricing_type === 'role') {
      service.price = 10;
      for (let i = 0; i < props.roles.length; i += 1) {
        service.role_executions.push({
          role_id: props.roles[i].id,
          price: '',
          duration: '00:45:00',
          processing: '00:00:00',
        });
      }
    }
    if (props.location && props.location.state && props.location.state.service) {
      // eslint-disable-next-line prefer-destructuring
      service = props.location.state.service;
      isFooterButtonActive = true;
      isNameSelected = true;
      // serviceNamed = true;
      isNewService = false;
    }
    this.state = {
      isFooterButtonActive,
      isNameSelected,
      category: selectedCategory,
      service,
      serviceTemplates: [],
      errorMessage: '',
      // serviceNamed,
      isNewService,
      isFirstPriceChange,
      isFirstDurationChange,
      isFirstProcessingChange,
    };
  }

  UNSAFE_componentWillMount() {
    if (!this.props.currentSalon) {
      navFor('AddServiceWrap.componentWillMount()', this.props).push({
        pathname: LINK.onboardingType,
        search: fromPropsToQueryString(this.props),
      });
    }
    this.props.getServiceTemplates();
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onRoleCheckboxClick = (roleId) => {
    const service = Object.assign({}, this.state.service);
    for (let i = 0; i < service.role_executions.length; i += 1) {
      if (service.role_executions[i].role_id === roleId) {
        service.role_executions.splice(i, 1);
        this.setState({ service }, () => this.checkButton());
        return;
      }
    }
    service.role_executions.push({
      role_id: roleId,
      price: '',
      duration: '00:45:00',
      processing: '00:00:00',
    });
    this.setState({ service }, () => this.checkButton());
  };
  onRolePriceChange = (roleId, value) => {
    const service = Object.assign({}, this.state.service);
    for (let i = 0; i < service.role_executions.length; i += 1) {
      if (service.role_executions[i].role_id === roleId) {
        service.role_executions[i].price = value;
        service.price = value;
        this.setState({ service }, () => this.checkButton());
        return;
      }
    }
  };
  onRolePriceBlur = (value) => {
    const service = Object.assign({}, this.state.service);
    if (this.state.isNewService && this.state.isFirstPriceChange) {
      for (let i = 0; i < service.role_executions.length; i += 1) {
        service.role_executions[i].price = value;
        service.price = value;
      }
      this.setState({ service, isFirstPriceChange: false }, () => this.checkButton());
    }
  };
  onRoleApplicationChange = (roleId, value) => {
    const service = Object.assign({}, this.state.service);
    if (this.state.isNewService && this.state.isFirstDurationChange) {
      for (let i = 0; i < service.role_executions.length; i += 1) {
        service.role_executions[i].duration = moment(value, 'HH:mm').format('HH:mm:ss');
        service.duration = value;
      }
      this.setState({ service, isFirstDurationChange: false }, () => this.checkButton());
      return;
    }
    for (let i = 0; i < service.role_executions.length; i += 1) {
      if (service.role_executions[i].role_id === roleId) {
        service.role_executions[i].duration = moment(value, 'HH:mm').format('HH:mm:ss');
        service.duration = value;
        this.setState({ service }, () => this.checkButton());
        return;
      }
    }
  };
  onRoleProcessingChange = (roleId, value) => {
    const service = Object.assign({}, this.state.service);
    if (this.state.isNewService && this.state.isFirstProcessingChange) {
      for (let i = 0; i < service.role_executions.length; i += 1) {
        service.role_executions[i].processing = moment(value, 'HH:mm').format('HH:mm:ss');
        service.processing = value;
      }
      this.setState({ service, isFirstProcessingChange: false }, () => this.checkButton());
      return;
    }
    for (let i = 0; i < service.role_executions.length; i += 1) {
      if (service.role_executions[i].role_id === roleId) {
        service.role_executions[i].processing = moment(value, 'HH:mm').format('HH:mm:ss');
        service.processing = value;
        this.setState({ service }, () => this.checkButton());
        return;
      }
    }
  };
  onServiceNameChange = (value) => {
    const service = { ...this.state.service };
    service.name = value;
    const serviceTemplates = [];
    if (value.length > 0) {
      if (this.props.serviceTemplates) {
        for (let i = 0; i < this.props.serviceTemplates.length; i += 1) {
          if (this.props.serviceTemplates[i].name.toLowerCase().indexOf(value.toLowerCase()) === 0) {
            serviceTemplates.push(this.props.serviceTemplates[i]);
          }
        }
      }
    }
    this.setState({ service, serviceTemplates }, () => this.checkButton());
  };
  onCategoryChange = (category) => {
    if (!category.id) {
      return;
    }
    const service = { ...this.state.service };
    service.category = category.id;
    this.setState({ service }, () => this.checkButton());
  };
  onDurationChange = (value) => {
    const service = { ...this.state.service };
    service.duration = moment(value, 'HH:mm').format('HH:mm:ss');
    this.setState({ service }, () => this.checkButton());
  };
  onProcessingChange = (value) => {
    const service = { ...this.state.service };
    service.processing = moment(value, 'HH:mm').format('HH:mm:ss');
    this.setState({ service }, () => this.checkButton());
  };
  onPriceChange = (value) => {
    const service = { ...this.state.service };
    service.price = value;
    this.setState({ service }, () => this.checkButton());
  };
  onPrincingChange = (value) => {
    const service = { ...this.state.service };
    service.variable_pricing = value;
    this.setState({ service }, () => this.checkButton());
  };
  onFooterButtonClicked = () => {
    if (!this.state.isFooterButtonActive) {
      return;
    }
    if (!this.state.isNameSelected) {
      this.setState({ isNameSelected: true });
    }
    if (this.state.service) {
      this.props.editService(this.state.service, this.props.currentSalon.id);
    }
    navFor('AddServiceWrap.componentWillMount()', this.props).push({
      pathname: LINK.onboardingServices,
      search: fromPropsToQueryString(this.props),
    });
  };
  addNewService = () => {
    this.setState({ isNameSelected: true }, () => this.checkButton());
  };
  selectTemplate = (service) => {
    const serviceToAdd = Object.assign({}, this.state.service);
    serviceToAdd.name = service.name;
    if (service.duration) {
      serviceToAdd.duration = service.duration;
    }
    if (service.processing) {
      serviceToAdd.processing = service.processing;
    }
    if (service.price) {
      serviceToAdd.price = service.price;
    }
    if (this.props.currentSalon.pricing_type === 'role') {
      for (let i = 0; i < serviceToAdd.role_executions.length; i += 1) {
        if (service.price) {
          serviceToAdd.role_executions[i].price = service.price;
        }
        if (service.duration) {
          serviceToAdd.role_executions[i].duration = service.duration;
        }
        if (service.processing) {
          serviceToAdd.role_executions[i].processing = service.processing;
        }
      }
    }
    this.setState({ service: serviceToAdd, isNameSelected: true }, () => this.checkButton());
  };
  checkButton = () => {
    let enabled = false;
    if (this.state.service && this.state.isNameSelected && this.state.service.price !== '' && this.state.service.duration !== '00:00:00') {
      enabled = true;
      for (let i = 0; i < this.state.service.role_executions.length; i += 1) {
        if (this.state.service.role_executions[i].price === '') {
          enabled = false;
        }
      }
      this.setState({ isFooterButtonActive: enabled });
    }
  };
  hideError = () => {
    this.setState({ errorMessage: '' });
  };

  render() {
    const { errorMessage, isFooterButtonActive, isNameSelected, serviceTemplates, category, service } = this.state;
    const { isFetching, categories, isPosting, t } = this.props;

    const serviceName = service && service.name;
    const categoryName = category?.name;
    const services = category && category.services;
    const description = determineDescription({ category, categoryName, services, t });

    return (
      <div data-bem="AddServiceWrap" className="content-wrap">
        {errorMessage && <PopupModalContainer popupTitle={t('common.error')} popupMessage={errorMessage} buttonText={t('common.buttons.okay')} buttonCallback={this.hideError} />}

        <HeaderContainer
          titleFirstPart={t('register.addServiceWrap.title')}
          description={description}
          backBtnCallBack={() =>
            void navFor('AddServiceWrap.render()', 'backBtnCallBack()', this.props).push({
              pathname: LINK.onboardingCategories,
              search: fromPropsToQueryString(this.props),
            })
          }
        />

        <AddService
          service={service}
          serviceName={service ? serviceName : ''}
          categories={categories}
          category={category}
          onServiceNameChange={this.onServiceNameChange}
          isNameSelected={isNameSelected}
          onCategoryChange={this.onCategoryChange}
          onRoleCheckboxChange={this.onRoleCheckboxClick}
          onRolePriceChange={this.onRolePriceChange}
          onRolePriceBlur={this.onRolePriceBlur}
          onRoleApplicationChange={this.onRoleApplicationChange}
          onRoleProcessingChange={this.onRoleProcessingChange}
          onDurationChange={this.onDurationChange}
          onProcessingChange={this.onProcessingChange}
          onPriceChange={this.onPriceChange}
          onPrincingChange={this.onPrincingChange}
          serviceTemplates={serviceTemplates}
          addNewService={this.addNewService}
          selectTemplate={this.selectTemplate}
        />
        <OnboardingFooter isFooterButtonActive={isFooterButtonActive} onButtonClick={this.onFooterButtonClicked} isLoading={isFetching || isPosting} />
        {(isPosting || isFetching) && <div className="load-blocker" />}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { onboarding, currentSalon } = state;
  const { services } = onboarding;
  const { roles } = onboarding;
  // eslint-disable-next-line object-curly-newline
  const { categories, serviceTemplates, isFetching, isPosting, isSaved, isServiceSaved } = services;
  // const { currentSalon } = salon;
  return {
    ...roles,
    serviceTemplates,
    categories,
    currentSalon,
    isFetching,
    isPosting,
    isSaved,
    isServiceSaved,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    editService(service, salonId) {
      dispatch(editService(service, salonId));
    },
    addService(service, categoryId, salonId) {
      dispatch(addService(service, categoryId, salonId));
    },
    getServiceTemplates() {
      dispatch(getServiceTemplates());
    },
    clearServicesState() {
      dispatch(clearServicesState());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AddServiceWrap));
